import styled from "styled-components";

export const IconToggleButton = styled.button`
    background: transparent;
    border: none;
    padding: 8px;
    border-radius: ${(props) => props.theme.shape.borderRadiusSm}px;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: ${(props) => props.theme.font.sizes.xl};
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        color: ${(props) => props.theme.palette.accent.light};
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
    }

    &:active {
        transform: scale(0.96);
    }
`;

export const ProfileTriggerButton = styled.button`
    background: transparent;
    border: none;
    padding: 6px 10px;
    border-radius: ${(props) => props.theme.shape.borderRadiusSm}px;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-family: ${(props) => props.theme.font.family};
    font-size: ${(props) => props.theme.font.sizes.md};
    transition: background-color 0.15s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
    }
`;

export const HeaderAvatar = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.palette.accent.light};
    color: ${(props) => props.theme.palette.white};
    font-size: ${(props) => props.theme.font.sizes.sm};
    font-weight: ${(props) => props.theme.font.weights.semiBold};
    flex-shrink: 0;
`;

export const LoginButton = styled.button`
    background-color: ${(props) => props.theme.palette.accent.dark};
    border: none;
    border-radius: ${(props) => props.theme.shape.borderRadiusSm}px;
    color: ${(props) => props.theme.palette.white};
    cursor: pointer;
    padding: 8px 20px;
    font-family: ${(props) => props.theme.font.family};
    font-size: ${(props) => props.theme.font.sizes.md};
    font-weight: ${(props) => props.theme.font.weights.semiBold};
    transition: background-color 0.15s ease, transform 0.1s ease;

    &:hover {
        background-color: ${(props) => props.theme.palette.accent.light};
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
    }

    &:active {
        transform: scale(0.98);
    }
`;